import React from 'react';

const OrderDetails = () => {
  return (
    <div id="App"></div>
  );
};

export default OrderDetails;
